import { authenticationStore } from "../../api/authentication/authentication.module";
import { VueEasyJwt } from "vue-easy-jwt";
import Vue from "vue";
import moment from "moment";

export const GlobalEvent = new Vue();

export interface IPaginationResponse {
  page: number;
  pageCount: number;
  perPage: number;
  total: number;
  skipped: number;
}

export function responseHandler(response: any) {
  const output: {
    status: boolean;
    data?: any;
    pagination: IPaginationResponse;
    message: string;
  } = response.data;

  // tslint:disable-next-line: no-console
  // console.log(output);
  if (output.status) {
    return output;
  }

  throw output;
}

export function showError(message: string) {
  throw new Error(message);
}

export class AuthenticationService {
  public jwt: any = new VueEasyJwt();

  public async checkLogin() {
    const token: any = authenticationStore.token;
    if (!token) showError("Unauthorized");
    const exp = this.jwt.decodeToken(token).exp;
    const today = Math.floor(new Date().getTime() / 1000);
    if (exp < today) showError("Unauthorized");
    // console.log(exp, today);
    // await authenticationStore.VerifyToken();

    const user = await authenticationStore.verifyToken();
    if (!user.roles.find((role: any) => role.slug === "artiste")) {
      await authenticationStore.LOGOUT();
      throw new Error("Unauthorized");
    }
    return user;
  }
}

export const formatDate = (date: string, format: string) => {
  return moment(date).format(format);
};

export const moneyFormat = (number: number) => {
  // console.log('number is', number);
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
